import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-folder-pop-up',
  templateUrl: './folder-pop-up.component.html',
  styleUrls: ['./folder-pop-up.component.scss']
})
export class FolderPopUpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
